import LabelTooltip from "./LabelTooltip";

export default LabelTooltip;
